import { useQuery } from '@tanstack/react-query';
import type { MenuProps } from 'antd';
import { payTypeUse } from '@/services/plan';

type PayTypeItem = {
  addressType?: number | string;
  payTypeName?: string;
};

type UsePayTypeMenuItemsOptions = {
  filter?: (item: PayTypeItem) => boolean;
};

export const formatPayTypeName = (name?: string) => name?.replace?.(/\(.*?\)/g, '') ?? '';

export const buildPayTypeMenuItems = (
  payTypes: PayTypeItem[] = [],
  options?: UsePayTypeMenuItemsOptions,
): MenuProps['items'] =>
  payTypes
    .filter((item) => options?.filter?.(item) ?? true)
    .map((item) => ({
      label: formatPayTypeName(item?.payTypeName),
      key: String(item?.addressType),
    }));

const usePayTypeMenuItems = (options?: UsePayTypeMenuItemsOptions) => {
  const payTypeUseRes = useQuery({
    queryKey: ['payTypeUse'],
    queryFn: payTypeUse,
  });

  const items = buildPayTypeMenuItems(payTypeUseRes?.data?.data ?? [], options);

  return {
    items,
    payTypeUseRes,
  };
};

export default usePayTypeMenuItems;
